<div class="panel panel-primary">
    <div class="panel-heading" data-testid="confirm-modal-title">{{title}}</div>
    <div class="panel-body">
      <p data-testid="confirm-modal-text">{{text}}</p>
    </div>
    <div class="panel-footer clearfix">
      <div class="pull-right">
        <button type="button" class="btn btn-danger" (click)="cancelClicked()" data-testid="confirm-modal-cancel-button">Cancel</button>
        <button type="button" class="btn btn-primary" (click)="confirmClicked()" data-testid="confirm-modal-confirm-button">Confirm</button>
      </div>
    </div>
  </div>